// Simple Arabic translations - No external library needed
const translations = {
    app: {
        dashboard: "لوحة التحكم",
        home: "الرئيسية",
        settings: "الإعدادات",
        reports: "التقارير",
        notifications: "الإشعارات",
        profile: "الملف الشخصي",
        logout: "تسجيل الخروج",
        admin: "المدير",
        user: "مستخدم",
        users: "المستخدمون",
        roles_permissions: "الأدوار والصلاحيات"
    },
    buttons: {
        add_new: "إضافة جديد",
        edit: "تعديل",
        save: "حفظ",
        cancel: "إلغاء",
        delete: "حذف",
        view: "عرض",
        details: "التفاصيل",
        search: "بحث",
        filter: "تصفية",
        export: "تصدير",
        print: "طباعة",
        refresh: "تحديث",
        back: "رجوع",
        confirm: "تأكيد",
        close: "إغلاق"
    },
    customers: {
        customers: "العملاء",
        add_customer: "إضافة عميل",
        edit_customer: "تعديل بيانات العميل",
        delete_customer: "حذف العميل",
        customer_profile: "ملف العميل",
        view_vehicles: "عرض المركبات",
        customer_balance: "رصيد العميل",
        customer_history: "سجل العميل"
    },
    vehicles: {
        vehicles: "المركبات",
        add_vehicle: "إضافة مركبة",
        edit_vehicle: "تعديل المركبة",
        delete_vehicle: "حذف المركبة",
        vehicle_details: "تفاصيل المركبة",
        update_mileage: "تحديث عداد الكيلومترات",
        service_history: "سجل الصيانة",
        plate_number: "رقم اللوحة",
        vin: "رقم الشاصي",
        model: "موديل السيارة",
        year: "سنة الصنع",
        mileage: "عداد الكيلومترات"
    },
    work_orders: {
        work_orders: "أوامر العمل",
        create_work_order: "إنشاء أمر عمل",
        edit_work_order: "تعديل أمر العمل",
        assign_technician: "تعيين فني",
        change_status: "تغيير الحالة",
        start_work: "بدء العمل",
        complete_work: "إنهاء العمل",
        deliver_vehicle: "تسليم المركبة",
        cancel_order: "إلغاء الأمر",
        job_description: "وصف العمل",
        estimated_time: "الوقت المتوقع",
        completion_date: "تاريخ الإنجاز",
        assigned_technician: "الفني المكلّف"
    },
    status: {
        status: "الحالة",
        open: "مفتوح",
        in_progress: "إصلاح",
        waiting_for_parts: "بانتظار قطع الغيار",
        delivering: "قيد التسليم",
        completed: "مكتمل",
        delivered: "تم التسليم",
        cancelled: "ملغى",
        diagnosis: "تشخيص",
        waiting_approval: "بانتظار الموافقة",
        quality_check: "فحص الجودة",
        ready: "جاهز للتسليم",
        quotation: "تعميد",
        approved: "معتمد",
        repair: "تحت الإصلاح"
    },
    staff: {
        technicians: "الفنيون",
        mechanic: "ميكانيكي",
        supervisor: "مشرف",
        add_technician: "إضافة فني",
        edit_technician: "تعديل بيانات الفني",
        assign_job: "إسناد مهمة",
        attendance: "الحضور",
        working_hours: "ساعات العمل",
        performance_report: "تقرير الأداء"
    },
    print: {
        print: "طباعة",
        print_operation: "طباعة العملية",
        invoice_number: "رقم الفاتورة"
    },
    operations_ui: {
        from_to: "من/إلى",
        notes: "البيان"
    },
    inventory: {
        inventory: "المخزون",
        parts_dashboard: "لوحة تحكم القطع",
        spare_parts: "قطع الغيار",
        suppliers: "الموردون",
        add_item: "إضافة صنف",
        edit_item: "تعديل الصنف",
        delete_item: "حذف الصنف",
        stock_in: "إضافة للمخزون",
        stock_out: "صرف من المخزون",
        low_stock_alert: "تنبيه نقص المخزون",
        item_code: "كود الصنف",
        quantity: "الكمية",
        unit_price: "سعر الوحدة"
    },
    invoices: {
        invoices: "الفواتير",
        create_invoice: "إنشاء فاتورة",
        edit_invoice: "تعديل الفاتورة",
        delete_invoice: "حذف الفاتورة",
        view_invoice: "عرض الفاتورة",
        print_invoice: "طباعة الفاتورة",
        apply_discount: "تطبيق خصم",
        add_tax: "إضافة ضريبة",
        invoice_number: "رقم الفاتورة",
        invoice_date: "تاريخ الفاتورة",
        total_amount: "المبلغ الإجمالي",
        discount: "خصم",
        vat: "ضريبة القيمة المضافة",
        net_amount: "صافي المبلغ"
    },
    payments: {
        payments: "المدفوعات",
        add_payment: "إضافة دفعة",
        payment_method: "طريقة الدفع",
        cash: "نقدًا",
        credit_card: "بطاقة ائتمان",
        bank_transfer: "تحويل بنكي",
        mark_as_paid: "تحديد كمدفوع",
        partial_payment: "دفعة جزئية",
        paid: "مدفوع",
        unpaid: "غير مدفوع",
        partially_paid: "مدفوع جزئيًا"
    },
    reports_module: {
        daily_report: "تقرير يومي",
        monthly_report: "تقرير شهري",
        financial_report: "تقرير مالي",
        profit_loss: "الأرباح والخسائر",
        cash_flow: "التدفق النقدي",
        export_pdf: "تصدير PDF",
        export_excel: "تصدير Excel",
        analytics: "التحليلات",
        summary: "ملخص",
        kpi: "مؤشرات الأداء"
    },
    auth: {
        login: "تسجيل الدخول",
        username: "اسم المستخدم",
        password: "كلمة المرور",
        remember_me: "تذكرني",
        forgot_password: "نسيت كلمة المرور؟",
        change_password: "تغيير كلمة المرور"
    },
    system: {
        backup: "نسخة احتياطية",
        restore: "استعادة",
        system_settings: "إعدادات النظام"
    },
    // Additional common texts
    messages: {
        success_saved: "تم الحفظ بنجاح",
        success_updated: "تم التحديث بنجاح",
        success_deleted: "تم الحذف بنجاح",
        error_occurred: "حدث خطأ",
        loading_data: "جاري تحميل البيانات...",
        no_results: "لا توجد نتائج",
        confirm_action: "هل أنت متأكد؟",
        action_cancelled: "تم الإلغاء",
        processing: "جاري المعالجة..."
    },
    forms: {
        required_field: "هذا الحقل مطلوب",
        invalid_email: "البريد الإلكتروني غير صالح",
        invalid_phone: "رقم الهاتف غير صالح",
        name: "الاسم",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني",
        address: "العنوان",
        notes: "ملاحظات",
        select: "اختر",
        select_option: "اختر خياراً"
    },
    operations: {
        title: "العمليات",
        subtitle: "إدارة عمليات البيع والشراء",
        new_operation: "عملية جديدة",
        account: "الحساب",
        select_account: "اختر الحساب",
        vehicle: "المركبة",
        select_vehicle: "اختر المركبة",
        visit: "الزيارة",
        date: "التاريخ",
        operation_type: "نوع العملية",
        purchase: "شراء",
        sale: "بيع",
        partner_type: "نوع الشريك",
        supplier: "مورد",
        customer: "عميل",
        partner_name: "اسم الشريك",
        add_item: "إضافة عنصر",
        item_type: "نوع العنصر",
        part: "قطعة",
        service: "خدمة",
        item_name: "اسم العنصر",
        quantity: "الكمية",
        price: "السعر",
        total: "الإجمالي",
        payment_method: "طريقة الدفع",
        cash: "نقدي",
        card: "بطاقة",
        transfer: "تحويل",
        subtotal: "المجموع الفرعي",
        create_operation: "إنشاء العملية",
        recent_operations: "العمليات الأخيرة",
        no_operations: "لا توجد عمليات",
        // camelCase keys used in Operations.jsx
        addItems: "العناصر",
        addItem: "إضافة عنصر",
        items: "العناصر",
        selectPart: "اختر قطعة",
        selectService: "اختر خدمة",
        selectAccount: "اختر الحساب",
        recentOperations: "العمليات الأخيرة",
        operationType: "نوع العملية",
        paymentMethod: "طريقة الدفع",
        account_required: "اختر الحساب",
        partner: "الشريك",
        submit: "حفظ",
        customerName: "اسم العميل",
        supplierName: "اسم المورد",
        customName: "اسم مخصص",
        credit: "آجل",
        SAR: "ر.س",
        // additional labels
        scopeLabel: "تصنيف العملية",
        scopeVehicle: "عملية مركبة",
        scopeWorkshop: "عملية ورشة عامة",
        operationDateLabel: "تاريخ العملية",
        no_accounts: "لا توجد حسابات",
        loading_accounts: "جاري تحميل الحسابات...",
        payment_receipt_optional: "إيصال الدفع (اختياري)",
        credit_unpaid: "آجل (غير مدفوع)",
        confirm_credit_payment: "تأكيد سداد الآجل",
        payment_confirm_failed: "فشل تأكيد السداد",
        qty: "الكمية",
        items_count: "العناصر",
        saved_successfully: "تم حفظ العملية",
        save_failed: "فشل حفظ العملية",
        items_required: "أضف عنصر واحد على الأقل قبل الحفظ",
        vehicle_finance: {
            workshop_due: "ذمم الورشة",
            suppliers_due: "ذمم الموردين",
            total_paid: "المدفوع",
            advance_paid: "دفعة مقدمة",
            balance: "المتبقي",
            credit: "رصيد للعميل"
        },
        select_vehicle_required: "اختر مركبة أولاً"
    },
    settings: {
        title: "الإعدادات",
        workshop_info: "معلومات الورشة",
        workshop_name: "اسم الورشة",
        workshop_phone: "رقم الهاتف",
        workshop_email: "البريد الإلكتروني",
        workshop_address: "العنوان",
        system_appearance: "النظام والمظهر",
        language: "اللغة",
        theme: "المظهر",
        currency: "العملة",
        light: "فاتح",
        dark: "داكن",
        arabic: "العربية",
        english: "English",
        save_changes: "حفظ التغييرات",
        saving: "جاري الحفظ...",
        tax_settings: "إعدادات الضريبة",
        enable_tax: "تفعيل الضريبة",
        tax_rate: "نسبة الضريبة"
    },
    parts: {
        title: "قطع الغيار",
        inventory: "المخزون",
        add_part: "إضافة قطعة",
        edit_part: "تعديل القطعة",
        part_number: "رقم القطعة",
        part_name: "اسم القطعة",
        category: "التصنيف",
        purchase_price: "سعر الشراء",
        selling_price: "سعر البيع",
        quantity: "الكمية",
        min_quantity: "الحد الأدنى",
        supplier: "المورد",
        location: "الموقع",
        low_stock: "مخزون منخفض",
        import_parts: "استيراد قطع الغيار",
        upload_image: "رفع صورة"
    },
    suppliers: {
        title: "الموردون",
        add_supplier: "إضافة مورد",
        supplier_name: "اسم المورد",
        contact_person: "الشخص المسؤول",
        city: "المدينة",
        rating: "التقييم"
    },
    vehicles_page: {
        new_vehicle: "استقبال مركبة جديدة",
        vehicle_info: "معلومات المركبة",
        customer_info: "معلومات العميل",
        services_info: "خدمات الصيانة",
        select_services: "اختر الخدمات",
        manual_service: "خدمة يدوية",
        service_name: "اسم الخدمة",
        service_price: "سعر الخدمة",
        add_manual: "إضافة يدوياً",
        assign_technician: "تعيين فني",
        customer_name: "اسم العميل",
        customer_phone: "رقم الهاتف",
        customer_email: "البريد الإلكتروني"
    },
    vehicle_details: {
        title: "تفاصيل المركبة",
        vehicle_info: "معلومات المركبة",
        customer_info: "معلومات العميل",
        status: "الحالة",
        assigned_technician: "الفني المسؤول",
        notes: "الملاحظات",
        update: "تحديث",
        updating: "جاري التحديث...",
        services: "الخدمات",
        parts: "القطع",
        files: "الملفات والمرفقات",
        operations: "العمليات",
        approvals: "الاعتمادات",
        visits: "الزيارات",
        add_service: "إضافة خدمة",
        add_part: "إضافة قطعة",
        upload_file: "رفع ملف",
        print: "طباعة",
        delete: "حذف",
        photo: "صورة",
        document: "مستند",
        invoice: "فاتورة",
        quotation: "عرض سعر",
        repair_report: "تقرير الإصلاح",
        new_visit: "زيارة جديدة",
        current_visit: "الزيارة الحالية",
        entry_date: "تاريخ الدخول",
        exit_date: "تاريخ الخروج",
        visit_notes: "ملاحظات الزيارة",
        brand_model: "الماركة والموديل",
        vin_number: "رقم الهيكل",
        color: "اللون",
        subtitle: "خيارات سريعة للمركبة",
        items_edit_hint: "يمكنك إضافة/تعديل الخدمات والقطع من جدول البنود أعلاه",
        registered_services: "الخدمات المسجّلة لهذه المركبة"
    },
    quick_actions: {
        title: "إجراءات سريعة",
        subtitle: "اختر إجراء لهذه المركبة",
        change_status: "تحديث الحالة",
        current_status: "الحالة الحالية",
        new_status: "الحالة الجديدة",
        print_quotation: "عرض سعر",
        print_invoice: "فاتورة",
        send_approval: "طلب اعتماد",
        add_operations: "العمليات",
        delete_vehicle: "حذف المركبة",
        confirm_delete: "هل أنت متأكد من الحذف؟",
        cancel: "إلغاء",
        confirm: "تأكيد",
        close: "إغلاق",
        vehicle_options: "خيارات المركبة",
        quick_actions: "إجراءات سريعة",
        diagnosis_report: "تقرير تشخيص",
        receipt: "سند قبض",
        details: "التفاصيل",
        spare_parts: "قطع الغيار",
        operations: "العمليات"
    },
    // Additional translations
    nav: {
        dashboard: "لوحة التحكم",
        operations: "العمليات",
        customers: "العملاء",
        technicians: "الفنيون",
        suppliers: "الموردون",
        inventory: "المخزون",
        services: "الخدمات",
        documents: "المستندات",
        finance: "المالية",
        archive: "الأرشيف",
        import: "استيراد البيانات",
        users: "المستخدمين",
        profile: "الملف الشخصي",
        settings: "الإعدادات",
        finance_accounting: "المالية والمحاسبة",
        chart_of_accounts: "دليل الحسابات",
        financial_statements: "القوائم المالية",
        journal: "دفتر اليومية",
        taxes: "الضرائب",
        abu_fahd_financial_ai: "أبوفهد - التحليل والتدقيق المالي",
        fault_knowledge: "قاعدة المعرفة",
        denso_diagnostics: "تشخيص دينسو",
        print_quotes: "الطباعة وعروض الأسعار",
        templates_manager: "إدارة المستندات والنماذج",
        workshop_system: "نظام إدارة الورشة",
        moltbot: "مولت بوت"
    },
    abu_fahad: {
        title: "أبوفهد",
        subtitle: "مساعد مالي",
        greeting: "مرحباً، أنا أبوفهد. ماذا تريد أن نراجع اليوم؟ يمكنك اختيار حساب للتدقيق أو كتابة سؤالك مباشرة.",
        new_chat: "محادثة جديدة",
        new_chat_greeting: "تم بدء محادثة جديدة. ما الذي تريد تحليله الآن؟ يمكنك اختيار حساب للتدقيق أو كتابة سؤالك مباشرة.",
        open_chat: "فتح محادثة أبوفهد",
        account_optional: "الحساب (اختياري)",
        no_account: "بدون تحديد حساب",
        placeholder: "اكتب سؤالك المالي هنا...",
        no_response: "تعذر الحصول على رد من أبوفهد حالياً.",
        connection_error: "تعذر الاتصال بأبوفهد. حاول مرة أخرى.",
        details: "تفاصيل",
        latency_note: "ملاحظة: قد يتأخر الرد 10-30 ثانية حسب الضغط."
    },
    dashboard: {
        title: "لوحة التحكم",
        overview: "نظرة عامة على الورشة",
        total_vehicles: "إجمالي المركبات",
        in_progress: "إصلاح",
        ready: "جاهز للتسليم",
        technicians: "الفنيين المتاحين",
        new_vehicle: "استقبال مركبة",
        search: "بحث باسم العميل أو رقم اللوحة...",
        // camelCase keys used in Dashboard.jsx
        totalVehicles: "إجمالي المركبات",
        inProgress: "تحت الإصلاح",
        newVehicle: "استقبال مركبة",
        searchPlaceholder: "بحث برقم اللوحة أو اسم العميل...",
        activeToday: "نشطة اليوم",
        deliveredToday: "تم التسليم اليوم",
        waitingParts: "بانتظار قطع الغيار",
        waitingPayment: "بانتظار السداد",
        inDelivery: "قيد التسليم",
        inDiagnosis: "قيد التشخيص",
        busyTechs: "مشغولون",
        freeTechs: "متاحون",
        // vehicle card labels
        entryDateLabel: "تاريخ الدخول",
        customerLabel: "العميل",
        progressLabel: "نسبة الإنجاز",
        responsibleTechnicianLabel: "الفني المسؤول",
        openVehicleDetails: "فتح تفاصيل المركبة",
        vinLabel: "رقم الهيكل (VIN)",
        visitsLabel: "عدد الزيارات",
        visitUnit: "زيارة",
        lastUpdateLabel: "آخر تحديث",
        estimatedCostLabel: "التكلفة التقديرية"
    },
    common: {
        all: "الكل",
        save: "حفظ",
        cancel: "إلغاء",
        delete: "حذف",
        edit: "تعديل",
        add: "إضافة",
        search: "بحث",
        loading: "جاري التحميل...",
        no_data: "لا توجد بيانات",
        success: "تم بنجاح",
        error: "حدث خطأ",
        confirm_delete: "هل أنت متأكد من الحذف؟",
        print: "طباعة",
        details: "التفاصيل",
        view: "عرض",
        total: "الإجمالي",
        currency: "ر.س",
        vehicle_finance: "ملخص مالي",
        vehicle_finance_subtitle: "تكاليف المركبة عبر جميع الزيارات",
        unknown: "غير معروف",
        not_specified: "غير محدد",
        urgent: "عاجل",
        basic_info: "المعلومات الأساسية",
        linking: "الربط",
        payment: "الدفع",
        payment_status: "حالة الدفع",
        issued: "صادرة",
        draft: "مسودة",
        paid: "مدفوع",
        unpaid: "غير مدفوع",
        delete_warning: "سيتم حذف العملية نهائيًا ولا يمكن التراجع.",
        description: "الوصف",
        optional: "اختياري"
    }
};
// Export all translations
export default translations;
